export const blockIconsHomeStadiaControllerNew = (
	<span className='material-symbols-outlined'>stadia_controller</span>
);
